import type { AccountCategoryModel, FrequencyEnum } from './account-category.type.ts';
import type { AccountRepresentativeListModel } from './account-representative.type.ts';
import type { MeetingStatusTypeEnum } from './meeting.type.ts';
import type { RepresentativeStatusEnum } from './representative-status.type.ts';

export enum EventTypeEnum {
  AvailabilitySlot = 1,
  MeetingEntry = 2,
}

export interface CalendarDayData {
  isToday: boolean;
  date: string;
  isCurrentMonth: boolean;
  events: CalendarEvent[];
  id: number;
}

export interface CalendarEvent {
  eventType: EventTypeEnum;
  key: string;
  id: number;
  start: string;
  end: string;
  accountId: number;
  accountKey: string;
  accountName?: string;
  location: string;
  canEdit: boolean;
  canRequest: boolean;
  canView: boolean;
  lastScheduledAppointment?: string;
  nextScheduledAppointment?: string;
  status: string;
  statusId: MeetingStatusTypeEnum;
  foodCategory: string;
  drugName: string;
  representative: EventRepresentativeModel;
  accountRepresentatives: AccountRepresentativeListModel[];
  accountCategories: AccountCategoryModel[];
  availabilitySlotRecurringSeriesKey?: string;
}

export interface EventRepresentativeModel {
  userId: number;
  representativeStatusId: RepresentativeStatusEnum;
  firstName: string;
  lastName: string;
  company: string;
  emailAddress: string;
  profilePhotoUrl: string;
  accountCategoryFrequencyId: FrequencyEnum;
  frequencyOverrideId: FrequencyEnum;
}
